namespace Nobox {
    export interface ChatmessagessImgForm {
        Type: Serenity.StringEditor;
        Files: Serenity.MultipleImageUploadEditor;
        File: Serenity.MultipleImageUploadEditor;
        Msg: Serenity.TextAreaEditor;
        RoomId: Serenity.StringEditor;
        From: Serenity.StringEditor;
        To: Serenity.StringEditor;
        AgentId: Serenity.IntegerEditor;
        Ack: Serenity.IntegerEditor;
    }

    export class ChatmessagessImgForm extends Serenity.PrefixedContext {
        static formKey = 'Chat.ChatroomsImgForm';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ChatmessagessImgForm.init)  {
                ChatmessagessImgForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.MultipleImageUploadEditor;
                var w2 = s.TextAreaEditor;
                var w3 = s.IntegerEditor;

                Q.initFormType(ChatmessagessImgForm, [
                    'Type', w0,
                    'Files', w1,
                    'File', w1,
                    'Msg', w2,
                    'RoomId', w0,
                    'From', w0,
                    'To', w0,
                    'AgentId', w3,
                    'Ack', w3
                ]);
            }
        }
    }
}
